export default "__VITE_ASSET__BGuiS2le__"